var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Gamer_Background_Mask_",
    "data-name": "Gamer (Background/Mask)",
    width: 24,
    height: 24,
    transform: "translate(-92 18)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_m\\xE1scara_5",
    "data-name": "Grupo de m\\xE1scara 5",
    transform: "translate(92 -18)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(-89.567 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M7.258,8.584H0l1.552-4.59A2.543,2.543,0,0,1,3.007,2.452L9.073,0,9.55.347,9.99,0l6.1,2.451A2.543,2.543,0,0,1,17.548,4l1.534,4.582Z",
    transform: "translate(0 11.404)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    d: "M2.169,2.178A2.229,2.229,0,0,0,4.317.7L2.57,0,2.13.347,1.678.018,1.59.026,0,.668A2.272,2.272,0,0,0,2.169,2.178Z",
    transform: "translate(7.42 11.404)",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    "data-name": "Vector 192",
    d: "M4.126,2.66A2.76,2.76,0,0,0,1.35.013C-.916-.245.175,3.392,1,5.243L4.126,5.5Z",
    transform: "translate(9.646 1.032)",
    fill: "#3b9349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    "data-name": "Vector 193",
    d: "M4.126-2.66A2.76,2.76,0,0,1,1.35-.013C-.916.245.175-3.392,1-5.243L4.126-5.5Z",
    transform: "translate(9.417 1.032) rotate(180)",
    fill: "#3b9349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    d: "M2.542,0V1.906h0a.485.485,0,0,1-.434.268H.434A.485.485,0,0,1,0,1.906H0V0Z",
    transform: "translate(8.279 9.845)",
    fill: "#f4aa79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    "data-name": "Vector 191",
    d: "M8.369,2.407C8.236,1.624,7.017.046,3.212,0c-1.1,0-.84.535-.573.8C1.97.669.53.527.117,1.032s.363,1.127.8,1.375c-.306.191-.7.768.172,1.547-.019.649.069,2.04.573,2.407s5.024-.115,7.221-.4C9.267,5.119,9.7,3.232,8.369,2.407Z",
    transform: "translate(4.371)",
    fill: "#504c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    d: "M.688,0h.688a0,0,0,0,1,0,0V1.948a0,0,0,0,1,0,0H.688A.688.688,0,0,1,0,1.261V.688A.688.688,0,0,1,.688,0Z",
    transform: "translate(14.001 7.908) rotate(180)",
    fill: "#49b75e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    d: "M.688,0h.688a0,0,0,0,1,0,0V1.948a0,0,0,0,1,0,0H.688A.688.688,0,0,1,0,1.261V.688A.688.688,0,0,1,.688,0Z",
    transform: "translate(5.062 5.96)",
    fill: "#49b75e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    d: "M0,0H6.354a0,0,0,0,1,0,0V3.177A3.177,3.177,0,0,1,3.177,6.354h0A3.177,3.177,0,0,1,0,3.177V0A0,0,0,0,1,0,0Z",
    transform: "translate(6.373 4.126)",
    fill: "#f6c9aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    "data-name": "Vector 190",
    d: "M6.017.688c-1.242.879-3.84,1.6-3.668.229-.8,1.089-2.017,1.467-1.6,0l-.63.917L0,0H6.476V1.834Z",
    transform: "translate(6.265 4.126)",
    fill: "#504c43"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 0.229,
    cy: 0.344,
    rx: 0.229,
    ry: 0.344,
    transform: "translate(7.927 6.693)",
    fill: "#504c43"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 0.229,
    cy: 0.344,
    rx: 0.229,
    ry: 0.344,
    transform: "translate(10.678 6.693)",
    fill: "#504c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    d: "M11.461,0V2.235H0V0Z",
    transform: "translate(3.801 17.765)",
    fill: "#275e86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    "data-name": "Vector 184",
    d: "M.056,1.431a.257.257,0,0,0,.253.3H.386a.257.257,0,0,0,.251-.313L.39.308a.064.064,0,0,0-.126,0Z",
    transform: "translate(9.207 6.967)",
    fill: "#f4aa79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    "data-name": "Vector 185",
    d: "M0,2.2V0",
    transform: "translate(3.831 17.788) rotate(0.79)",
    fill: "none",
    stroke: "#c3c3c3",
    strokeWidth: 0.635,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    "data-name": "Vector 186",
    d: "M0,2.2V0",
    transform: "matrix(1, 0.003, -0.003, 1, 15.269, 17.788)",
    fill: "none",
    stroke: "#c3c3c3",
    strokeWidth: 0.635,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    "data-name": "Vector 187",
    d: "M0,0A1.176,1.176,0,0,0,.8.321,1.006,1.006,0,0,0,1.574,0",
    transform: "translate(8.758 9.249)",
    fill: "none",
    stroke: "#f4aa79",
    strokeLinecap: "round",
    strokeWidth: 0.193,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    "data-name": "Vector 188",
    d: "M0,0A.77.77,0,0,0,.526.211.659.659,0,0,0,1.032,0",
    transform: "translate(11.48 6.445) rotate(180)",
    fill: "none",
    stroke: "#504c43",
    strokeLinecap: "round",
    strokeWidth: 0.126,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    "data-name": "Vector 189",
    d: "M0,0A.77.77,0,0,0,.526.211.659.659,0,0,0,1.032,0",
    transform: "translate(8.615 6.445) rotate(180)",
    fill: "none",
    stroke: "#504c43",
    strokeLinecap: "round",
    strokeWidth: 0.126,
    strokeDasharray: "0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    d: "M0,0H.573a0,0,0,0,1,0,0V.172A.172.172,0,0,1,.4.344H.172A.172.172,0,0,1,0,.172V0A0,0,0,0,1,0,0Z",
    transform: "translate(12.855 7.908)",
    fill: "#504c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union-2",
    "data-name": "Union",
    d: "M2.407,0V.8a.344.344,0,0,1-.344.344H0v.115H2.063A.458.458,0,0,0,2.521.8V0Z",
    transform: "translate(10.678 8.252)",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 0.802,
    height: 0.344,
    rx: 0.172,
    transform: "translate(10.563 9.284)",
    fill: "#504c43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuario);
export default __webpack_public_path__ + "static/media/usuario.2e191d38c256ddae674dd8aaa2466a7c.svg";
export { ForwardRef as ReactComponent };